import type { ElementRef, ComponentPropsWithoutRef } from "react";

import { forwardRef } from "react";

export const IconClick = forwardRef<
  ElementRef<"svg">,
  ComponentPropsWithoutRef<"svg">
>((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M5.76667 5.79667L4.54167 4.56083M12.2992 5.79667L13.5242 4.56083M4.54083 13.6275L5.76583 12.3908M9.0325 4.14917V2.5M4.1325 9.09417H2.5M14.0625 14.03L17.2408 12.775C17.3175 12.7443 17.3833 12.6914 17.4296 12.623C17.4759 12.5546 17.5006 12.4738 17.5006 12.3912C17.5006 12.3087 17.4759 12.2279 17.4296 12.1595C17.3833 12.0911 17.3175 12.0382 17.2408 12.0075L9.60333 8.995C9.52898 8.96623 9.44785 8.95975 9.36988 8.97638C9.2919 8.993 9.22047 9.032 9.16431 9.08859C9.10816 9.14519 9.06972 9.21693 9.05371 9.29503C9.0377 9.37313 9.04481 9.45421 9.07417 9.52833L12.0592 17.2375C12.1942 17.5875 12.6842 17.5875 12.8192 17.2375L14.0625 14.03Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
IconClick.displayName = "IconClick";
